import $ from 'jquery';
import jqueryValidation from 'jquery-validation';

export class Callbackform {

    init () {

        // 🔹 INPUT TISZTÍTÁS
        $('#phone_number').on('input', function () {
            this.value = this.value.replace(/\D/g, '');
        });

        $("#callback").on('click', function (e) {

            e.preventDefault();

            let form = $('#callback-form');

            form.validate({
                groups: {
                    nameGroupCallback: "aszf privacy_policy name email phone_number "
                },
                rules: {
                    name: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                    phone_number: {
                        required: true
                    },
                    aszf: {
                        required: true
                    },
                    privacy_policy: {
                        required: true
                    }
                },
                messages: {
                    name: {
                        required: "Minden mező kitöltése kötelező!",
                    },
                    email: {
                        required: "Minden mező kitöltése kötelező!",
                    },
                    phone_number: {
                        required: "Minden mező kitöltése kötelező!"
                    },
                    aszf: {
                        required: 'Általános Szerződési Feltételei kitöltése kötelező!'
                    },
                    privacy_policy: {
                        required: 'Adatvédelmi Tájékoztató kitöltése kötelező!'
                    },
                    nameGroupCallback: {
                        required: "Minden mező kitöltése kötelező!"
                    }
                }
            });

            let isValid = form.valid();
            if (isValid) {

                // 🔹 itt is biztosítjuk
                let phone = form.find("#phone_number").val().replace(/\D/g, '');

                let data = {
                    name: form.find("#name").val(),
                    email: form.find("#email").val(),
                    phone_number: phone
                };

                $.ajax({
                    type: 'POST',
                    url: ajaxurl,
                    dataType: 'json',
                    data: {
                        action: 'Callback',
                        data: data
                    },
                    beforeSend: function () {
                        $("#loading-image").show();
                        $("#callbacks").prop('disabled', true);
                    },
                    success: function (res) {
                        $("#loading-image").hide();
                        $("#panelsStayOpen-collapseCallback .box").fadeTo("slow", 0.00, function () {
                            $(this).slideUp(1000, function () {
                                $(this).remove();
                                $("#panelsStayOpen-collapseCallback .thank-you-text").removeClass("d-none");
                            });
                        });
                        $('html, body').animate({
                            scrollTop: $("#panelsStayOpen-Callback").offset().top + (-40)
                        }, 1500);
                    },
                    error: function (res) {

                    }
                });
            }
        });
    }
}


